export default "__VITE_ASSET__evv16lL$__"